// @flow

import styled from 'styled-components';
import breakpoint from 'styled-components-breakpoint';

import theme from '@lib/theme';

import {
  ConsultationIcon, ContactUs, TreatmentCostIcon, SecondOpinionIcon
} from '@images/svg/index';


export const AppointmentHeading = styled.h2`
  font-size: 32px;
  font-weight: 600;
  background-color: white;
  padding: 12px;
  text-align: center;
  color: #202020;

  @media (max-width: 1025px) {
    font-size: 28px;
  }

  @media (max-width: 500px) {
    font-size: 26px;
  }
`;


export const StyledContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-bottom: 10px;
  padding: 20px;
`;

export const StyledImage = styled.img`
  height: 140px;
  width: 140px;

  @media (max-width: 1025px) {
    height: 120px;
    width: 120px;
  }

  @media (max-width: 1025px) {
    height: 100px;
    width: 100px;
  }
`;

export const ButtonWrapper = styled.div`
  margin: 20px auto;

  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const StyledButtonComponent = styled.div`
  display: flex !important;
  text-decoration: none;
  white-space: nowrap;
  align-items: center;
  background-color: #bbdefb;
  box-shadow: 0 1.5px 4px rgb(0 0 0 / 0.2);
  color: #202020;
  height: 32px;
  border-radius: 10px;
  margin-bottom: 20px;
  text-align: center;
  cursor: pointer;
  padding: 16px 16px 16px 16px;
  width: 50%;
  margin-top: auto;

  &:hover {
    background-color: #5fa6bf;
    color: white;
    color: #fff;
  }

  &:hover {
    svg,
    path {
      fill: ${theme.colors.white};
      stroke: ${theme.colors.white};
      stroke-width: 0.2px;
    }
    color: white;
  }

  @media (max-width: 480px) {
    width: 60%;
    padding: 10px;
  }

  @media (max-width: 370px) {
    width: 70%;
    padding: 10px;
  }

  @media (max-width: 300px) {
    width: 80%;
    padding: 10px;
  }
`;

export const ServicesText = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 22px;

  line-height: 32px;

  ${breakpoint('tablet', 'desktop')`
    font-size: 20px;
  `}

  ${breakpoint('mobile', 'tablet')`
    font-size: 14px;
  `}

   @media (max-width: 1025px) {
    font-size: 18px;
  }

  @media (max-width: 530px) {
    font-size: 16px;
  }

  @media (max-width: 490px) {
    font-size: 14px;
  }

`;

export const StyledTreatmentCostIcon = styled(TreatmentCostIcon)`
  width: 30px;
  margin-left: 20px;
  margin-right: 20px;
  svg,
  path {
    fill: ${theme.colors.blackShade};
    stroke: ${theme.colors.blackShade};
    stroke-width: 0.5px;
  }


  ${breakpoint('tablet', 'desktop')`
    height: 70%;
    margin-left: 20px;
    margin-right: 20px;
    svg,
    path {
      fill: ${theme.colors.blackShade};
      stroke: ${theme.colors.blackShade};
      stroke-width: 0.5px;
    }
  
  `}

  ${breakpoint('mobile', 'tablet')`
    margin-left: 10px;
    margin-right: 10px; 
    svg,
    path {
      fill: ${theme.colors.blackShade};
      stroke: ${theme.colors.blackShade};
      stroke-width: 0.5px;
    }
  
  `}

   @media (max-width: 1025px) {
    width: 28px;
    margin-left: 10px;
    margin-right: 10px;
  }

  @media (max-width: 530px) {
    width: 26px;
  }

  @media (max-width: 490px) {
    width: 24px;
  }

  @media (max-width: 370px) {
    width: 22px;
    margin-left: 5px;
    margin-right: 5px;
  }

  @media (max-width: 350px) {
    width: 20px;
  }
`;

export const StyledOnlineConsultationIcon = styled(ConsultationIcon)`
  width: 30px;
  margin-left: 20px;
  margin-right: 20px;
  svg,
  path {
    fill: ${theme.colors.blackShade};
    stroke: ${theme.colors.blackShade};
    stroke-width: 0.5px;
  }


  ${breakpoint('tablet', 'desktop')`
    height: 70%;
    margin-left: 20px;
    margin-right: 20px;
    svg,
  path {
    fill: ${theme.colors.blackShade};
    stroke: ${theme.colors.blackShade};
    stroke-width: 0.5px;
  }

  `}

  ${breakpoint('mobile', 'tablet')`
    margin-left: 10px;
    margin-right: 10px; 
    svg,
  path {
    fill: ${theme.colors.blackShade};
    stroke: ${theme.colors.blackShade};
    stroke-width: 0.5px;
  }

  `}

   @media (max-width: 1025px) {
    width: 28px;
    margin-left: 10px;
    margin-right: 10px;
  }

  @media (max-width: 530px) {
    width: 26px;
  }

  @media (max-width: 490px) {
    width: 24px;
  }

  @media (max-width: 370px) {
    width: 22px;
    margin-left: 5px;
    margin-right: 5px;
  }

  @media (max-width: 350px) {
    width: 20px;
  }
`;

export const StyledSecondOpinionIcon = styled(SecondOpinionIcon)`
  width: 30px;
  margin-left: 20px;
  margin-right: 20px;
  svg,
  path {
    fill: ${theme.colors.blackShade};
    stroke: ${theme.colors.blackShade};
    stroke-width: 0.5px;
  }


  ${breakpoint('tablet', 'desktop')`
    height: 70%;
    margin-left: 20px;
    margin-right: 20px;
    svg,
  path {
    fill: ${theme.colors.blackShade};
    stroke: ${theme.colors.blackShade};
    stroke-width: 0.5px;
  }

  `}

  ${breakpoint('mobile', 'tablet')`
    margin-left: 10px;
    margin-right: 10px; 
    svg,
  path {
    fill: ${theme.colors.blackShade};
    stroke: ${theme.colors.blackShade};
    stroke-width: 0.5px;
  }

  `}

  @media (max-width: 1025px) {
    width: 30px;
    margin-left: 10px;
    margin-right: 10px;
  }

  @media (max-width: 530px) {
    width: 26px;
  }

  @media (max-width: 490px) {
    width: 24px;
  }

  @media (max-width: 370px) {
    width: 22px;
    margin-left: 5px;
    margin-right: 5px;
  }

  @media (max-width: 350px) {
    width: 20px;
  }
`;

export const StyledContactUsIcon = styled(ContactUs)`
  width: 30px;
  margin-left: 20px;
  margin-right: 20px;
  svg,
  path {
    fill: ${theme.colors.blackShade};
    stroke: ${theme.colors.blackShade};
    stroke-width: 0.5px;
  }

  ${breakpoint('tablet', 'desktop')`
    height: 70%;
    margin-left: 20px;
    margin-right: 20px;
    svg,
    path {
      fill: ${theme.colors.blackShade};
      stroke: ${theme.colors.blackShade};
      stroke-width: 0.5px;
    }
  `}

  ${breakpoint('mobile', 'tablet')`
    margin-left: 10px;
    margin-right: 10px; 
    svg,
    path {
      fill: ${theme.colors.blackShade};
      stroke: ${theme.colors.blackShade};
      stroke-width: 0.5px;
    }
  `}

   @media (max-width: 1025px) {
    width: 28px;
    margin-left: 10px;
    margin-right: 10px;
  }

  @media (max-width: 530px) {
    width: 26px;
  }

  @media (max-width: 490px) {
    width: 24px;
  }

  @media (max-width: 370px) {
    width: 22px;
    margin-left: 5px;
    margin-right: 5px;
  }

  @media (max-width: 350px) {
    width: 20px;
  }
`;
